import firebase from "firebase/compat/app";
import "firebase/compat/auth";
//import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
};
const _app = firebase.initializeApp(firebaseConfig);

const getAuth = () => {
    // getAuth();
    return _app.auth();
}

export {
    getAuth,
    firebase
};
